/* SPDX-License-Identifier: AGPL-3.0-or-later */

import {Component, computed, inject} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {AuthService} from 'src/app/services/auth.service';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {filter, firstValueFrom, map, switchMap} from 'rxjs';
import {TournamentEndpointService} from '@api';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
    username: string = '';
    tournamentService = inject(TournamentEndpointService);
    router = inject(Router);
    authService = inject(AuthService);

    url = toSignal(
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(event => (event as NavigationEnd).urlAfterRedirects.split('/')),
        ),
    );

    isTournamentPath = computed(() => {
        const path = this.url();
        return path != undefined && path.length > 3 && path[1] === 'admin' && path[2] === 'tournaments' && !isNaN(+path[3]);
    });

    tournament = toSignal(
        toObservable(this.isTournamentPath).pipe(
            switchMap(async isTournamentPath => {
                if (isTournamentPath) {
                    const path = this.url()!;
                    const tournamentId = +path[3];
                    return firstValueFrom(this.tournamentService.get(tournamentId));
                } else {
                    return null;
                }
            }),
        ),
    );

    constructor() {
        this.username = this.authService.getUsername()!;
    }

    logout() {
        this.authService.logoutUser();
        this.router.navigate(['/admin/']);
    }
}
